webpackJsonp([35783957827783],{

/***/ 223:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.query = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _animejs = __webpack_require__(22);
	
	var _animejs2 = _interopRequireDefault(_animejs);
	
	var _reactHelmet = __webpack_require__(41);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _Flower = __webpack_require__(46);
	
	var _Flower2 = _interopRequireDefault(_Flower);
	
	var _SVG = __webpack_require__(51);
	
	var _SVG2 = _interopRequireDefault(_SVG);
	
	var _animations = __webpack_require__(54);
	
	var _Header = __webpack_require__(47);
	
	var _Header2 = _interopRequireDefault(_Header);
	
	var _Logo = __webpack_require__(26);
	
	var _Logo2 = _interopRequireDefault(_Logo);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Home = function (_Component) {
	  _inherits(Home, _Component);
	
	  function Home() {
	    _classCallCheck(this, Home);
	
	    return _possibleConstructorReturn(this, _Component.apply(this, arguments));
	  }
	
	  Home.prototype.componentDidMount = function componentDidMount() {
	    if (!this.props.location.state) (0, _animejs2.default)((0, _animations.fadeIn)(['#center-container', '#petal-nip', '#petal-paid', '#petal-vref', '#base'], 1000, null, 200));else {
	      document.querySelectorAll(['.heading', '.text-list', 'nav.back-button', '.typing-text-wrapper', '#animated-logo', '#TLcontrols']).forEach(function (i) {
	        return i.style.display = 'none';
	      });
	      (0, _animejs2.default)((0, _animations.fadeIn)(['#center-container', '#petal-nip', '#petal-paid', '#base', '#petal-vref'], 200, function () {
	        return document.getElementById('real-flower').style.display = 'block';
	      }, 200));
	      (0, _animejs2.default)((0, _animations.scaleUp)(this.props.location.state.elementId, [10, 1], 300));
	      (0, _animejs2.default)((0, _animations.translateY)('header', [-100, 0]));
	    }
	  };
	
	  Home.prototype.render = function render() {
	    return _react2.default.createElement(
	      'div',
	      null,
	      _react2.default.createElement(_reactHelmet2.default, {
	        title: this.props.data.site.siteMetadata.title,
	        meta: [{
	          name: 'description',
	          content: this.props.data.site.siteMetadata.description
	        }]
	      }),
	      _react2.default.createElement(
	        _Header2.default,
	        null,
	        _react2.default.createElement(
	          _SVG2.default,
	          {
	            id: 'header-logo',
	            height: '48px',
	            width: '350px',
	            viewBox: '20 0 420 150'
	          },
	          _react2.default.createElement(_Logo2.default, null)
	        )
	      ),
	      _react2.default.createElement(
	        'main',
	        null,
	        _react2.default.createElement(
	          _SVG2.default,
	          { id: 'flower', viewBox: '50 -40 680 700', fitToScreen: true },
	          _react2.default.createElement(_Flower2.default, { page: 'Home' })
	        )
	      )
	    );
	  };
	
	  return Home;
	}(_react.Component);
	
	exports.default = Home;
	var query = exports.query = '** extracted graphql fragment **';

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-index-js-81398b26413761585183.js